/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  withAnalyticChannelProvider
 */

import hoistNonReactStatics from 'hoist-non-react-statics'
import React from 'react'
import type { GetProps, InferableComponentEnhancerWithProps } from 'react-redux'
import { type AnalyticChannelContextType, AnalyticChannelProvider } from './AnalyticChannelProvider'

export const withAnalyticChannelProvider =
  (options: AnalyticChannelContextType): InferableComponentEnhancerWithProps<{}, {}> =>
  // @ts-expect-error
  (WrappedComponent) => {
    const withAnalyticChannelProvider = (forwardProps: GetProps<typeof WrappedComponent>) => {
      return (
        <AnalyticChannelProvider {...options}>
          {/* @ts-expect-error */}
          <WrappedComponent {...forwardProps} />
        </AnalyticChannelProvider>
      )
    }
    hoistNonReactStatics(withAnalyticChannelProvider, WrappedComponent)
    return withAnalyticChannelProvider
  }
